<template lang="html">

  <section class="add-traveler">
    <div class="pageHeading">
      <h1>Add a participant to your account</h1>
    </div>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1">Select Trip</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 2" step="2">Traveler Info</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 3" step="3">Billing Options</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="4">Review</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card
                  class="mb-5"
                  color=""
                  height="200px"
          >
            <h1>Select the trip</h1>
            <br/>
            <v-radio-group v-model="selectedTripData">
              <v-radio
                      v-for="trip in tripsDataForUser"
                      :value="trip"
                      :key="trip.tripID"
                      :disabled="trip.remainingSpaceSlots == 0"
              >
                <template slot="label">
                  <v-flex>
                  <span style="width: 100%">
                    {{trip.tripID}} ({{trip.tripName}})</span>
                  <span style=" color:red" v-if="trip.remainingSpacePercent > 0 && trip.remainingSpacePercent < 11"> Only {{trip.remainingSpaceSlots}} remaining slots!</span>
                  <span style=" color:red" v-else-if="trip.remainingSpacePercent == 0"> Sorry, the trip has reached its maximum number of participants. Please contact your group leader.</span>
                  </v-flex>
                </template>
              </v-radio>
            </v-radio-group>
          </v-card>

          <v-btn :disabled="selectedTripData.tripID == undefined"
                  color="primary"
                  @click="e1++"
          >
            Get Started!
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="2">

          <h3>Traveler Info</h3>
          <br>
          <v-card
                  class="mb-5"
                  color="grey lighten-1"
          >
            <v-form>
              <v-container >

                <p>(Full Legal Name as it appears on a government issued ID if applicable)</p>
                <v-layout row wrap>

                  <v-flex xs12 sm4>
                    <v-text-field
                            v-validate="'required'"
                            v-model="userData.firstName"
                            label="First Name *"
                            required
                    ></v-text-field>
                  </v-flex>

                    <v-flex xs12 sm4>
                        <v-text-field
                                v-validate="'required'"
                                v-model="userData.middleName"
                                label="Middle Name"
                                required
                        ></v-text-field>
                    </v-flex>

                  <v-flex xs12 sm4>
                    <v-text-field
                            v-validate="'required'"
                            v-model="userData.lastName"
                            label="Last Name *"
                            required
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                  <v-layout row wrap>
                      <v-flex xs12 sm4>
                          <v-text-field
                                  v-validate="'required'"
                                  v-model="userData.gender"
                                  label="Gender *"
                                  required
                          ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm4>
                          <v-dialog
                                  ref="dialogDOB"
                                  v-model="modalDOB"
                                  :return-value.sync="userData.DOB"
                                  persistent
                                  lazy
                                  full-width
                                  width="290px"
                          >
                              <v-text-field
                                      slot="activator"
                                      :value="DOBFormatted"
                                      label="Date Of Birth *"
                                      prepend-icon="event"
                                      readonly
                              ></v-text-field>
                              <v-date-picker ref="DOBPicker" v-model="userData.DOB"
                                             :max="maximumDOB()"
                                             min="1920-01-01"
                                             >
                                  <v-spacer></v-spacer>
                                  <v-btn flat color="primary" @click="modalDOB = false">Cancel</v-btn>
                                  <v-btn flat color="primary" @click="$refs.dialogDOB.save(userData.DOB); checkDOB(userData.DOB)">OK</v-btn>
                              </v-date-picker>
                          </v-dialog>
                      </v-flex

                      <v-flex xs12 sm4>
                          <v-select
                                  :items="travelerTypes"
                                  label="Traveler Type *"
                                  v-model="userData.type"
                          ></v-select>
                      </v-flex>

                  </v-layout>
                <v-layout row wrap>

                  <v-flex xs12 sm3>
                    <v-text-field
                            v-validate="'required'"
                            v-model="userData.phoneNumber"
                            label="Phone Number *"
                            required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-text-field
                            v-validate="'required'"
                            v-model="userData.email"
                            label="Email Address *"
                            required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="userData.allergies"
                            label="Dietary Restrictions"
                            required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                  <v-layout row wrap>
                      <v-flex xs12  v-if="selectedTripData.customOptions != undefined && selectedTripData.customOptions.length > 0">
                        <v-divider></v-divider>
                        <h3>{{selectedTripData.customOptionsTitle}} *</h3>
                        <v-layout row wrap justify-space-around>

                          <v-checkbox v-model="userData.customOptionsSelection" v-for="option in selectedTripData.customOptions"
                                      hide-details :value="option.ID" :label="option.label" ></v-checkbox>

                        </v-layout>
                        <v-divider></v-divider>
                      </v-flex>
                  </v-layout>

              </v-container>
            </v-form>


            <small>* Marks Required Field</small>

          </v-card>
          <v-btn @click="e1--" flat>Previous</v-btn>
          <v-btn :disabled = "!isTravelerInfoComplete()"
                 color="primary"
                 @click="e1++"
          >
            Continue
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="3">

          <h3>Billing Options</h3>
          <br>

          <v-card
                  class="mb-5"
                  color=""
                  height="200px"
          >
            <v-form>
              <v-container>
                <v-layout row wrap>

                  <v-flex xs12 sm12>
                    <v-radio-group v-model="roomSelection">
                      <v-radio
                              :label="`Quad Occupancy ($` + selectedTripData.quadPrice + `)`"
                              value="4"
                              key="quad"
                      ></v-radio>
                      <v-radio
                              :label="`Triple Occupancy ($` + selectedTripData.triplePrice + `)`"
                              value="3"
                              key="triple"
                      ></v-radio>
                      <v-radio
                              :label="`Double Occupancy ($` + selectedTripData.doublePrice + `)`"
                              value="2"
                              key="double"
                      ></v-radio>
                      <v-radio
                              :label="`Single Occupancy ($` + selectedTripData.singlePrice + `)`"
                              value="1"
                              key="single"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>

                </v-layout>
              </v-container>
            </v-form>
          </v-card>


          <v-btn @click="e1--" flat>Previous</v-btn>
          <v-btn @click="e1++"
                  color="primary"
                 :disabled="roomSelection == 0"
          >
            Review
          </v-btn>

        </v-stepper-content>
        <v-stepper-content step="4">

          <v-card>
            <v-list two-line>


              <v-list-tile class="mainSectionHeadingInList" @click="">
                <v-list-tile-action>
                  <v-icon color="indigo">person</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>Basic Information</v-list-tile-title>
                </v-list-tile-content>

              </v-list-tile>

              <v-divider inset></v-divider>

              <v-list-tile @click="">
                <v-list-tile-action>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{userData.firstName + " " + userData.middleName + " " + userData.lastName}}</v-list-tile-title>
                  <v-list-tile-sub-title>Name</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="">
                <v-list-tile-action></v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{userData.type}}</v-list-tile-title>
                  <v-list-tile-sub-title>Type</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="">
                <v-list-tile-action></v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{userData.gender}}</v-list-tile-title>
                  <v-list-tile-sub-title>Gender</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="">
                <v-list-tile-action></v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{userData.allergies}}</v-list-tile-title>
                  <v-list-tile-sub-title>Dietary Restrictions</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>



              <v-list-tile  class="mainSectionHeadingInList" @click="">
                <v-list-tile-action>
                  <v-icon color="indigo">phone</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Contact</v-list-tile-title>
                </v-list-tile-content>



              </v-list-tile>

              <v-divider inset></v-divider>
              <v-list-tile @click="">
                <v-list-tile-action>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{userData.phoneNumber}}</v-list-tile-title>
                  <v-list-tile-sub-title>Phone</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                </v-list-tile-action>
              </v-list-tile>


              <v-list-tile  class="mainSectionHeadingInList" @click="">
                <v-list-tile-action>
                  <v-icon color="indigo">near_me</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Trip Options</v-list-tile-title>
                </v-list-tile-content>

              </v-list-tile>

              <v-divider inset></v-divider>
              <v-list-tile @click="">
                <v-list-tile-action>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{occupancySpelledOut(roomSelection)}}</v-list-tile-title>
                  <v-list-tile-sub-title>Room</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                </v-list-tile-action>
              </v-list-tile>


              <v-list-tile @click="">
                <v-list-tile-action></v-list-tile-action>

                <v-list-tile-content v-if="selectedTripData.customOptions != undefined && userData.customOptionsSelection.length > 0">
                  <v-list-tile-title>{{selectedTripData.customOptionsTitle}}</v-list-tile-title>
                  <v-list-tile-sub-title v-for="option in selectedTripData.customOptions" v-if="userData.customOptionsSelection.includes(option.ID)">{{option.label}}</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                </v-list-tile-action>
              </v-list-tile>




              <v-list-tile  class="mainSectionHeadingInList" @click="">
                <v-list-tile-action>
                  <v-icon color="indigo">payment</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Billing</v-list-tile-title>
                </v-list-tile-content>




              </v-list-tile>


              <v-divider inset></v-divider>



              <v-list-tile @click="">
                <v-list-tile-action>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>1st Payment</v-list-tile-title>
                  <v-list-tile-sub-title>${{(getPricing - Number(selectedTripData.depositAmount))/4}}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-content>
                  <v-list-tile-title>2nd Payment</v-list-tile-title>
                  <v-list-tile-sub-title>${{(getPricing - Number(selectedTripData.depositAmount))/4}}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-content>
                  <v-list-tile-title>3rd Payment</v-list-tile-title>
                  <v-list-tile-sub-title>${{(getPricing - Number(selectedTripData.depositAmount))/4}}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-content>
                  <v-list-tile-title>4th Payment</v-list-tile-title>
                  <v-list-tile-sub-title>${{(getPricing - Number(selectedTripData.depositAmount))/4}}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>


              <v-divider inset></v-divider>



              <v-list-tile @click="">
                <v-list-tile-action>
                </v-list-tile-action>




                <v-list-tile-content>
                  <v-list-tile-title>${{Number(selectedTripData.depositAmount)}}</v-list-tile-title>
                  <v-list-tile-sub-title>Deposit</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-content>
                  <v-list-tile-title>${{getPricing}}</v-list-tile-title>
                  <v-list-tile-sub-title>Total Cost</v-list-tile-sub-title>
                </v-list-tile-content>


              </v-list-tile>





            </v-list>
          </v-card>

          <br/>

          <v-btn @click="e1--"
                  color="secondary" dark
          >
            Go Back
          </v-btn>
          <v-btn @click="addTheTraveler"
                  color="primary"
          >
            Correct, Add Traveler!
          </v-btn>

        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </section>

</template>

<script lang="js">
    import moment from 'moment'
  export default  {
    name: 'add-traveler',
    props: [],
    mounted() {
        var vueThis = this;

        // vueThis.tripsDataForUser = this.$structuredData.trips

        this.$services.trips.find().then((result) => {

            result.data.forEach((trip) => {

                trip.remainingSpacePercent = 100 -  ((trip.participantCount / Number(trip.participantLimit)) * 100)
                trip.remainingSpaceSlots = (Number(trip.participantLimit) - trip.participantCount)

                if(trip.remainingSpacePercent < 0) {
                    trip.remainingSpacePercent = 0
                    trip.remainingSpaceSlots = 0
                }

                vueThis.tripsDataForUser.push(trip)
            })

            console.log('trip look', vueThis.tripsDataForUser)
        })
    },
    data() {
      return {
          travelerTypeMinor: false,
          userData: {
              DOB: '',
              gender: '',
              type: '',
              firstName: '',
              middleName: '',
              lastName: '',
              emergencyContact: '',
              customOptionsSelection: [],
              email: '',
              phoneNumber: '',

          },
          roomSelection: 0,
          vegaterian: false,
          selectedTripData: {},
          tripsDataForUser: [],
          e1: 0,
          tripsListGroup: 1,
          modalDOB: false,
          DOBFormatted: ''
      }
    },
    watch: {
        modalDOB (val) {
              val && setTimeout(() => (this.$refs.DOBPicker.activePicker = 'YEAR'))
          },
    },
    methods: {
        maximumDOB() {
            return moment().subtract(1, 'year').format('YYYY-MM-DD')
        },
        isTravelerInfoComplete() {
            console.log('check traveler info complete')
            if (this.userData.DOB.length > 5 &&
                //this.userData.emergencyContact.length > 2 &&
                this.userData.email.indexOf("@") != -1 && this.userData.email.indexOf(".") != -1 && this.userData.email.length > 5 &&
                this.userData.phoneNumber.length > 9 &&
                this.userData.gender.trim().length > 0 &&
                this.userData.type.trim().length > 0 &&
                this.userData.firstName.length > 1 &&
                this.userData.lastName.length > 1 &&
                ((this.selectedTripData.customOptions == undefined || this.selectedTripData.customOptions.length == 0) || this.userData.customOptionsSelection.length > 0)
            ) {
                return true;
            } else {
                return false;
            }
        },
        checkDOB(dob) {
            this.DOBFormatted = moment(dob).format('MM/DD/YYYY')
            console.log('test',dob)
            let birthday = +new Date(dob);
            let age = ~~((Date.now() - birthday) / (31557600000));

            if(age < 18) {
                this.travelerTypeMinor = true;
                this.userData.type = "Student"

            } else {
                this.travelerTypeMinor = false;
            }
        },
        occupancySpelledOut(roomNum) {
            console.log('in spelled out', roomNum)
            switch (roomNum) {
                case '1':
                    return "Single Occupancy"
                    break;
                case '2':
                    return "Double Occupancy"
                    break;
                case '3':
                    return "Triple Occupancy"
                    break;
                case '4':
                    return "Quad Occupancy"
                    break;
                default:
                    return '';
            }
        },
        addTheTraveler() {
            var vueThis = this
            vueThis.addParticipant().then((result) => {
                console.log('added part', result)
                this.$addParticipant(result)
                vueThis.$emit("alertUser", "success", "Traveler Added! Please pay the deposit to activate")
                vueThis.$router.push('/')
            }).catch(function(error) {
                console.error('Error!', error);
                vueThis.$emit("alertUser", "error", "Cannot create participant: " + error.message)
            })
        },
        createOrFetchUser() {
            return this.$services.users.create({
                "email": this.userData.email,
                "password": "passwordUsedForEtcEtc",
                "firstName" : this.userData.firstName,
                "lastName" : this.userData.lastName,
                "middleName" : this.userData.middleName,
                "invited" : true,
                "ParentUser": this.$feathers.get('user')._id,
                "notifsRead":0,
                "phone" : this.userData.phoneNumber,
                "gender" : this.userData.gender,
                "billingAddress" : {},
                "resetToken": "",
                "permissions": [ this.userData.type.toLowerCase() ],
                "subUsers": [],
                "trips": [this.selectedTripData._id],
                "setup" : false,
                "disabled" : false,
                "emailVerified" : false
            })
        },
        addParticipant() {
            console.log('addParticipant', this.userData, this.getPricing)
            return this.$services.participants.create({
                "TripID": this.selectedTripData._id,
                "email": this.userData.email,
                "firstName" : this.userData.firstName,
                "costAtSignUp" : this.getPricing,
                "middleName" : this.userData.middleName,
                "lastName" : this.userData.lastName,
                "DOB" : this.userData.DOB,
                "phone" : this.userData.phoneNumber,
                "gender" : this.userData.gender,
                "allergies" : this.userData.allergies,
                "type": this.userData.type,
                "ParentUser": this.$feathers.get('user')._id,
                "Group": this.userData.customOptionsSelection,
                "Occupancy": Number(this.roomSelection),
                "PaymentProgress": 0
            })

        }
    },
    computed: {
        travelerTypes() {
          if(!this.travelerTypeMinor) {
              return ['Chaperone','Student','Adult','Minor']
          }  else {
              return ['Student','Minor']
          }
        },
        getPricing() {
            switch (this.roomSelection) {
                case '1':
                    return Number(this.selectedTripData.singlePrice)
                    break;
                case '2':
                    return Number(this.selectedTripData.doublePrice)
                    break;
                case '3':
                    return Number(this.selectedTripData.triplePrice)
                    break;
                case '4':
                    return Number(this.selectedTripData.quadPrice)
                    break;
                default:
                    return 0;
            }
        }
    }
}
</script>

<style scoped lang="scss">
  .add-traveler {

  }
  .mainSectionHeadingInList{
    background: #ededed;
    border-bottom: black 1px solid;
  }
  .mainSectionHeadingInList .v-list__tile__title {
    color: black;
    font-size: 20px;
  }
  .mainSectionHeadingInList .v-icon {
    font-size: 30px;
  }
</style>
